import { DatePicker, Modal, Select, Upload } from "antd";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { post } from "../../../services/services";
import { ApiURL } from "../../../services/apiConstants";
import TextAreaInput from "../../../components/TextAreaInput";
import "react-medium-image-zoom/dist/styles.css";
import useImageUpload from "../../../hooks/useImageUpload";
import moment from "moment";

function ViewDailyShipStaffTask() {
  const { id } = useParams();
  const [errors, set_errors] = useState({});
  const [task_details, set_task_details] = useState("");
  const [department, set_department] = useState("");
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [previewTitle, setPreviewTitle] = useState("");
  const [initialPhotos, setInitialPhotos] = useState([]);
  const { fileList, setFileList } = useImageUpload(initialPhotos);
  const [logDate, set_LogDate] = useState(null);
  const [component, set_component] = useState("");

  const VIEW_DAILY_SHIP_STAFF_TASK_APIS = () => {
    const FORM_DATA = new FormData();
    FORM_DATA.append("daily_task_report_id", atob(id));
    FORM_DATA.append("request_type", "view");
    post(ApiURL.company_single_daily_task_report, FORM_DATA).then((res) => {
      if (res?.status == true) {
        const dailyData = res?.data;
        set_task_details(dailyData?.task_details);
        set_department(dailyData?.department);
        setInitialPhotos(dailyData.photos);
        set_LogDate(dailyData?.log_date_time);
        set_component(dailyData?.component || "");
      } else {
        const errors = res?.errors || {};
        set_errors(errors);
      }
    });
  };

  const handleChange = ({ fileList }) => {
    setFileList(fileList);
  };

  const handlePreview = async (file) => {
    let src = file.url;
    if (!src && file.originFileObj) {
      src = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.originFileObj);
        reader.onload = () => resolve(reader.result);
      });
    }
    setPreviewImage(src);
    setPreviewTitle(file.name);
    setPreviewVisible(true);
  };

  useEffect(() => {
    VIEW_DAILY_SHIP_STAFF_TASK_APIS();
  }, []);

  return (
    <>
      <div className="white-container">
        <br />
        <h3>Daily Ship Staff Task Information </h3>
        <br />
        <div className="row">
          <div className="col-12">
            <div className="input-box">
              <label>Select Photo</label>
              <Upload
                accept="image/*"
                multiple
                fileList={fileList}
                onChange={handleChange}
                onPreview={handlePreview}
                beforeUpload={() => false}
                listType="picture-circle"
              ></Upload>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-6">
            <div className="input-box">
              <label>Date & Time</label>
              <DatePicker
                disabled
                showTime
                format="YYYY-MM-DD HH:mm:ss"
                placeholder="Select Date & Time"
                value={logDate ? moment(logDate, "YYYY-MM-DD HH:mm:ss") : null}
                // onChange={onChangeDateTime}
                style={{ width: "100%" }}
              />
            </div>
          </div>
          <div className="col-6">
            <div className="input-box">
              <label>Department</label>
              <Select
                disabled
                value={department}
                placeholder="--Select Department --"
                style={{ width: "100%" }}
                onChange={(value) => set_department(value)}
              >
                <Select.Option value="Engine">Engine</Select.Option>
                <Select.Option value="Deck">Deck</Select.Option>
                <Select.Option value="Galley">Galley</Select.Option>
              </Select>
              {errors?.department && <span style={{ color: "red" }}>{errors?.department}</span>}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-6">
            <div className="input-box">
              <label>Component</label>
              <Select
                disabled
                value={component || undefined}
                placeholder="--Select Component --"
                style={{ width: "100%" }}
              >
                <Select.Option value={component}>{component}</Select.Option>
              </Select>
            </div>
          </div>
          <div className="col-6">
            <TextAreaInput
              disabled
              label="Task Details"
              rows={2}
              placeholder="Task Details"
              maxLength={1000}
              value={task_details}
              onChange={(e) => set_task_details(e.target.value)}
              errors={errors.task_details}
            />
          </div>
        </div>
      </div>
      <Modal
        visible={previewVisible}
        title={previewTitle}
        footer={null}
        onCancel={() => setPreviewVisible(false)}
      >
        <img
          alt="example"
          style={{
            width: "100%",
            maxWidth: "900px",
            maxHeight: "400px",
            objectFit: "contain",
          }}
          src={previewImage}
        />
      </Modal>
    </>
  );
}

export default ViewDailyShipStaffTask;
